import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import InputField from "common/customInputField";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { programSearch, clearProgramSearchData } from "store/programBuilder/actionCreator";
import { toast } from "react-toastify";
import "./style.scss";

const SearchFields = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initialState = {
    programId: "",
    userId: "",
    customerName: "",
    description: "",
    fromDate: "",
    toDate: "",
    parentNumber: "",
    parentName: "",
  };
  const [searchFields, setSearchFields] = useState(initialState);

  const handleSearch = () => {
    const payload = {
      id: searchFields?.programId,
      userId: searchFields?.userId,
      customer: searchFields?.customerName,
      description: searchFields?.description,
      fromDate: searchFields?.fromDate,
      toDate: searchFields?.toDate,
      parentName: searchFields?.parentName,
      parentNumber: searchFields?.parentNumber,
    };
    dispatch(programSearch(payload)).catch((err) => {
      toast.error("Error while fetching results, Please try again.");
    });
  };

  const handleClear = () => {
    setSearchFields(initialState);
    dispatch(clearProgramSearchData());
  };

  const handleChange = (e) => {
    const key = e.target.id;
    const value = e.target.value;
    setSearchFields({ ...searchFields, [key]: value });
  };

  return (
    <div className="container-fluid search-form-container">
      <div className="search-form-container__title d-flex justify-content-between align-items-center flex-column flex-md-row align-items-md-center">
        <span className="search-form-container__title--text mb-4 mb-md-0">Program Search</span>
        <div className="d-flex align-items-center">
          <Button variant="outline-primary" className="create-quote-btn" onClick={() => navigate("createProgram")}>
            Create New Program
          </Button>
        </div>
      </div>
      <div className="search-form-container__fields">
        <form className="search-form-container__fields__form">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
              <InputField
                type="text"
                label="Program ID"
                id="programId"
                placeholder="Enter Program ID"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={searchFields.programId}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
              <InputField
                type="text"
                label="User ID"
                placeholder="Enter User ID"
                id="userId"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={searchFields.userId}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
              <InputField
                type="text"
                label="Customer Name"
                placeholder="Enter Customer Name"
                id="customerName"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={searchFields.customerName}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
              <InputField
                type="text"
                label="Description"
                placeholder="Enter Description"
                id="description"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={searchFields.description}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
              <InputField
                type="date"
                label="Updated Date Start"
                placeholder="Select a Date"
                id="fromDate"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={searchFields.fromDate}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
              <InputField
                type="date"
                label="Updated Date End"
                placeholder="Select a Date"
                id="toDate"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={searchFields.toDate}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
              <InputField
                type="text"
                label="Parent Number"
                placeholder="Enter Parent Number"
                id="parentNumber"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={searchFields.parentNumber}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
              <InputField
                type="text"
                label="Parent Name"
                placeholder="Enter Parent Name"
                id="parentName"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={searchFields.parentName}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
          </div>
        </form>
      </div>
      <div className="d-flex search-form-container__fields__btn">
        <Button onClick={handleSearch}>Search</Button>
        <Button variant="outline-primary" className="mx-3" onClick={handleClear}>
          Clear
        </Button>
      </div>
    </div>
  );
};

export default SearchFields;
